export class Step1 {
    constructor() {}
    intitule = 'stepper.form.commun.mapa.step1';
    getclassificationorganisme = 'bloc_commun.mapa.getclassificationorganisme';
    getacheteurpublic = 'bloc_commun.mapa.getacheteurpublic';
    getspan1 = 'bloc_commun.mapa.getspan1';
    getnum = 'bloc_commun.mapa.getnum';
    gettypevoie = 'bloc_commun.mapa.gettypevoie';
    getnomvoie = 'bloc_commun.mapa.getnomvoie';
    getcp_e = 'bloc_commun.mapa.getcp_e';
    getcp = 'bloc_commun.mapa.getcp';
    getville = 'bloc_commun.mapa.getville';
    getpays = 'bloc_commun.mapa.getpays';
    getspan2 = 'bloc_commun.mapa.getspan2';
    getCorrespondant = 'bloc_commun.mapa.getcorrespondant'
    getcivilite = 'bloc_commun.mapa.getcivilite';
    getnom = 'bloc_commun.mapa.getnom';
    getpren = 'bloc_commun.mapa.getpren';
    getfonc = 'bloc_commun.mapa.getfonc';
    getposte = 'bloc_commun.mapa.getposte';
    gettel = 'bloc_commun.mapa.gettel';
    getmel = 'bloc_commun.mapa.getmel';
    getfax = 'bloc_commun.mapa.getfax';
    geturl = 'bloc_commun.mapa.geturl';
    geturlprofilacheteur = 'bloc_commun.mapa.geturlprofilacheteur';
    getspan3 = 'bloc_commun.mapa.getspan3';
    getdeptpub = 'bloc_commun.mapa.getdeptpub';
    getrappel = 'bloc_commun.mapa.getrappel_liste_avi_';
    getspan4 = 'bloc_commun.mapa.getspan4';
    getspan5 = 'bloc_commun.mapa.getspan5';

}
